<span class="site-info-directives" tooltip="{{ tooltipMessage }}" tooltip-placement="bottom">
    <span class="fa-stack signature-icon">
        <i class="fa fa-regular fa-file-lines fa-stack-1x"></i>
        <i class="fa fa-stack-1x" [ngClass]="icon"></i>
    </span>
    <span class="signature-text"> {{ status }}</span>
</span>
